import React from 'react';
import { EnhancedCartItem } from '~/utils/use-cart-items';
import BundleLineItem from './BundleLineItem';
import GiftCardLineItem from './GiftCardLineItem';
import KitLineItem from './KitLineItem';
import ProductLineItem from './ProductLineItem';

type Props = {
  lineItem: EnhancedCartItem;
  confirmed?: boolean;
};

const LineItem = ({ lineItem, confirmed = false }: Props) => {
  if (lineItem.isBundle) {
    if (lineItem.parts && lineItem.parts.length > 0) {
      return <BundleLineItem item={lineItem} confirmed={confirmed} />;
    } else {
      return <KitLineItem item={lineItem} confirmed={confirmed} />;
    }
  }
  if (lineItem.giftCards && lineItem.giftCards.length > 0) {
    return <GiftCardLineItem item={lineItem} confirmed={confirmed} />;
  }
  return <ProductLineItem item={lineItem} confirmed={confirmed} />;
};

export default LineItem;
